import Global from "@/scripts/Global"
import SessionManager from "@/Manager/Session.manager"
import VueSignals from '@/scripts/VueSignals'
export default {
    name: 'ChannelPurpose',
    data() {
        return {
            new_purpose: '',
            channelPurpose: SessionManager.getActiveChannel().channel_purpose,
        }
    },
    mounted() {
        document.getElementById('channel_purpose_edit').focus();
        if (this.channelPurpose.length > 0) {
            this.new_purpose = this.channelPurpose;
        }
    },
    methods: {
        editChannel() {
            Global.globalValue(VueSignals.EDIT_CHANNEL, this.new_purpose);
        },
        clear() {
            this.new_purpose = '';
            document.getElementById('channel_purpose_edit').focus();
        }
    }
}
